import { FeedbackLabel } from 'v2/core/entities/feedback';

const AVERAGE_CHARACTER_LENGTH = 8;
const CHIPS_GAP = 8;
const CHIP_ICON_WIDTH = 20;
const CHIP_BORDER_WIDTH = 1;
const CHIP_ICON_RIGHT_MARGIN = 4;
const CHIP_PADDING = 8;
const CHIP_WIDTH_WITHOUT_TEXT =
  CHIP_ICON_WIDTH +
  CHIP_ICON_RIGHT_MARGIN +
  2 * CHIP_PADDING +
  2 * CHIP_BORDER_WIDTH;

export const getMaxDisplayedLabelsCount = (
  availableWidth: number,
  labels: FeedbackLabel[],
) => {
  let maxDisplayedLabelsCount = 0;
  let remainingWidth = availableWidth;

  if (!labels || remainingWidth < 0) {
    return 0;
  }

  for (const label of labels) {
    const labelsCharacterWidth =
      label.displayName.length * AVERAGE_CHARACTER_LENGTH;
    const totalChipWidth = labelsCharacterWidth + CHIP_WIDTH_WITHOUT_TEXT;
    remainingWidth -= totalChipWidth + CHIPS_GAP;

    if (remainingWidth < 0) {
      break;
    }

    maxDisplayedLabelsCount++;
  }

  return maxDisplayedLabelsCount;
};
